<script lang="ts">
	import { page } from '$app/stores';

	import NavigationFooter from '$lib/components/NavigationFooter/NavigationFooter.svelte';
	import { getHubStores } from '$lib/stores/hubStores';
	import { isAllCollection } from '$lib/types/Collections';
	import { _ } from 'svelte-i18n';

	const { collections } = getHubStores();

	$: currentCollectionSlug = $page.data.postsFilters?.collectionSlug || '';

	const link = {
		href: '',
		label: '',
		name: '',
	};

	let prevLink = link;
	let nextLink = link;

	$: currentCollectionIndex = $collections.find(
		(collection) => collection.slug === currentCollectionSlug
	)?.index;
	$: hasAllCollection = $collections.some((collection) => isAllCollection(collection));

	$: if (currentCollectionIndex !== undefined) {
		if (hasAllCollection && currentCollectionSlug !== '') {
			// This block runs when `All` is in collection and `All` is not active collection
			// 'All' is in collections if hasAllCollection is true
			// 'All' is active collection if currentCollectionSlug is empty
			prevLink = {
				href: `/${$page.params.hubPrefix}/${$collections[currentCollectionIndex].slug}`,
				label: $_('common.previous'),
				name: $collections[currentCollectionIndex].name,
			};
		} else if (currentCollectionIndex > 0) {
			// This block runs when `All` is not present in collections
			// 'currentCollectionIndex > 0' is used to make sure that it don't go out of bound while accessing collections
			prevLink = {
				href: `/${$page.params.hubPrefix}/${$collections[currentCollectionIndex - 1].slug}`,
				label: $_('common.previous'),
				name: $collections[currentCollectionIndex - 1].name,
			};
		} else {
			prevLink = link;
		}

		if (currentCollectionIndex < $collections.length - 1) {
			if (currentCollectionSlug == '' || !hasAllCollection) {
				// This block runs when 'All' is not in collections or if 'All' is active selection
				// 'All' is active collection if currentCollectionSlug is empty
				// ''All' is in collections if hasAllCollection is true'
				nextLink = {
					href: `/${$page.params.hubPrefix}/${$collections[currentCollectionIndex + 1].slug}`,
					label: $_('common.next'),
					name: $collections[currentCollectionIndex + 1].name,
				};
			} else if (currentCollectionIndex < $collections.length - 2) {
				// This block runs when `All` is in collections
				// 'currentCollectionIndex < $collections.length - 2' is used to make sure that it don't go out of bound while accessing collections
				nextLink = {
					href: `/${$page.params.hubPrefix}/${$collections[currentCollectionIndex + 2].slug}`,
					label: $_('common.next'),
					name: $collections[currentCollectionIndex + 2].name,
				};
			} else {
				nextLink = link;
			}
		} else {
			nextLink = link;
		}
	}
</script>

<NavigationFooter {prevLink} {nextLink} />
